import axios from "infra/http";
import { useQuery } from "react-query";
import { TenantMeResponse } from "../typings/user";

function useTenantsComPermissao(permissao: string) {
  return useQuery(`/v1/auth/tenants-com-permissao`, async () => {
    const { data } = await axios.get<TenantMeResponse[]>(
      `/v1/auth/tenants-com-permissao`,
      {
        params: {
          permissao,
        },
      }
    );

    return data;
  });
}

export default useTenantsComPermissao;
